export class PartnerPendingAccountAccessRequestResponse {
  constructor(
    public readonly hasPending: boolean,
    public readonly accountAccessRequestId: number,
    public readonly userEmail: string,
  ) {}
}
